// Dépendances
import jQuery from 'jquery';
window.jQuery = jQuery;
window.$ = jQuery;

import validate from 'jquery-validation';
import 'jquery-validation/dist/localization/messages_fr.js';
import smartbanner from 'smartbanner.js';

window.toastr = require('toastr');
import swal from 'sweetalert2';
window.swal = swal;


// Modules Hegyd
require('hegyd/products/resources/assets/js/main-fo.js');
require('hegyd/core/resources/assets/js/hegyd-core.js');
require('hegyd/core/resources/assets/js/hegyd-gtm.js');
require('hegyd/news-v2/resources/assets/js/frontend/main.js');
require('hegyd/content-builder/resources/assets/js/main.js');
require('hegyd/slides/resources/assets/js/main-fo.js');
require('hegyd/ecommerce-v2/resources/assets/js/frontoffice/main-fo.js');

// Projet
// Utilisation d'un polyfills pour la compatibilité des custom elements avec safari notamment.
import '@ungap/custom-elements';
import './Pages/main-pages.js';

require('./components/components');
require('../_inte/js/main.js');
